import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text-gray-600 dark:text-gray-300" };
const _hoisted_2 = ["onSubmit"];
import { createNamespacedHelpers } from 'vuex';
const { mapMutations: mapWorkspaceMutations } = createNamespacedHelpers('newWorkspace');
import componentI18n from '@/i18n/componentI18n';
import { TEAM_CONSTANTS } from '@/constants/index';
const __default__ = {
    ...componentI18n('components.workspaces.team_form'),
    computed: {
        getMaxLength() {
            return TEAM_CONSTANTS.MAX_NAME_LENGTH;
        }
    },
    mounted() {
        this.$refs.team.$el.focus();
    },
    methods: {
        ...mapWorkspaceMutations(['incrementStep']),
        handleSubmit() {
            if (this.canAdvanceTeamStep) {
                this.incrementStep();
            }
        }
    }
};
import { useNewTeamStore } from '@/pinia_stores/newTeam';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'TeamForm',
    props: {
        isPartOfWorkspaceCreation: { type: Boolean, default: false }
    },
    setup(__props) {
        const store = useNewTeamStore();
        const handleSubmit = () => {
            if (store.canAdvanceStep) {
                store.incrementStep();
            }
        };
        return (_ctx, _cache) => {
            const _component_text_field = _resolveComponent("text-field");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("h1", _hoisted_1, _toDisplayString(__props.isPartOfWorkspaceCreation ? _ctx.$t('choose_first_team_name') : _ctx.$t('choose_team_name')), 1),
                _createElementVNode("form", {
                    class: "mt-6",
                    onSubmit: _withModifiers(handleSubmit, ["prevent"])
                }, [
                    _createVNode(_component_text_field, {
                        ref: "team",
                        modelValue: _unref(store).teamName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(store).teamName) = $event)),
                        "bottom-hint": __props.isPartOfWorkspaceCreation ? _ctx.$t('recommendation') : null,
                        label: _ctx.$t('team_name'),
                        required: "",
                        limit: _ctx.getMaxLength,
                        error: _unref(store).nameHasValidLength ? null : _ctx.$t('errors.name.too_long')
                    }, null, 8, ["modelValue", "bottom-hint", "label", "limit", "error"])
                ], 40, _hoisted_2)
            ]));
        };
    }
});
